/* PopUp Window
====================================================*/
$(function() {
	$(".popup").click(function(){
		window.open(this.href,"WindowName","width=500,height=640,resizable=yes,scrollbars=yes,top=10,left=10,toolbar=no,location=no,directories=no,status=no,menubar=no");
		return false;
	});
});

/* PopUp Ads Close Bt
====================================================*/
$(function() {
	$("#closeAds").click(function(){
		$("#popupAdsWrap").hide();
	});
});
/* PopUp Ads SlideIn / Out
====================================================*/
$(function(){
	var mainTop = $('#PageContainer').offset().top;
	var popupAds = $('#popupAdsWrap');
	var flug = true;
	$(window).scroll(function () {
		if(flug){
			flug = false;
			setTimeout(function(){
				var winTop = $(this).scrollTop();
				if (winTop <= mainTop/2) {
					popupAds.animate({'right': '30px','bottom': '-500px'}, 400, "linear");
				} else if (winTop > mainTop/2) {
					popupAds.animate({'right': '30px','bottom': '0px'}, 400, "linear");
				}
				flug = true;
				return flug;
			}, 1000);
		}
	});
});
/* fixed cart button / fixed vaiant button
====================================================*/
$(function(){
	var mainTop = $('#initialCartBt').offset().top;
	var initialCartBtCart = $('#initialCartBt .add-to-cart');
	var initialVariantBt = $('#initialVariantBt');
  	var initialVariantBtWrapper = $('#initialVariantBt .variant-wrapper');
	var flug = true;
	$(window).scroll(function () {
		if(flug){
			flug = false;
				var winTop = $(this).scrollTop();
				if (winTop <= mainTop + 200) {
					initialVariantBt.removeClass("fixedBt");
					initialCartBtCart.removeClass("fixedCart");
					initialVariantBtWrapper.removeClass("fixedVariant");
				} else {
					initialVariantBt.addClass("fixedBt");
					initialCartBtCart.addClass("fixedCart");
					initialVariantBtWrapper.addClass("fixedVariant");
				}
				flug = true;
				return flug;
		}
	});
});
$(document).on("change", 'input[name="updates[]"]', function () {
  var input = this;
  var newQty = parseInt(input.value, 10);
  var key = input.getAttribute("data-id");

  if (!key || isNaN(newQty)) return;

  fetch('/cart.js')
    .then(function(res) {
      return res.json();
    })
    .then(function(cart) {
      var changedItem = cart.items.find(function(item) {
        return item.key === key;
      });

      if (!changedItem || !changedItem.properties || !changedItem.properties._group_id) return;

      var groupId = changedItem.properties._group_id;

      var targets = cart.items.filter(function(item) {
        return item.properties &&
               item.properties._group_id === groupId &&
               item.key !== key;
      });

      return Promise.all(targets.map(function(target) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: target.key,
            quantity: newQty
          })
        });
      }));
    })
    .then(function() {
      location.reload();
    })
    .catch(function(err) {
      console.error('名入れ・イラストオプション同期エラー:', err);
    });
});